import React from "react";
import { CabinetProvider } from "./Cabinet/CabinetContext";
import Cabinet from "./Cabinet/Cabinet";
import Explainer from "./Cabinet/Explainer";

function CabinetView() {
  return (
    <>
      <CabinetProvider>
        <Cabinet />
      </CabinetProvider>
      <Explainer />
    </>
  );
}

export default CabinetView;
